<template>
  <div>
    <v-layout row wrap>
      <v-flex v-if="isAdmin" lg6>
        <v-card class="dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
            <v-toolbar-title>{{getString('Crea comunicazione (admin)')}}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <div>
              <v-flex xs12>
                <v-text-field
                  maxlength="30"
                  counter="30"
                  v-model="titleAdmin"
                  solo
                  :label="getString('Titolo')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 class="elevation-3">
                <editor
                  api-key="vn43j4ndioj2ysq09jicr7yfha8fvqcp8kye03mrgsixspv4"
                  v-model="messageAdmin"
                  :init="{selector: 'textarea', 
                                    language_url : '../../../static/languages/tinymce/it.js',
                                     menubar: true,
                                     min_height: 367,
                                     branding: false
                                    }"
                ></editor>
              </v-flex>
              <div :class="{'counter': true, 'counter-red': messageAdmin.length > 1900}">
                <h5>{{countCharAdmin}}/2000</h5>
              </div>
              <v-layout row wrap>
                <v-flex lg4>
                  <v-checkbox :label="getString('Email')" v-model="cb_EmailAll"></v-checkbox>
                </v-flex>
                <v-flex lg4>
                  <v-checkbox :label="getString('Messaggio a sito')" v-model="cb_AlertShops"></v-checkbox>
                </v-flex>
                <v-flex lg4>
                  <v-checkbox :label="getString('Push a tutti')" v-model="cb_PushAll"></v-checkbox>
                </v-flex>
              </v-layout>
              <v-flex xs12 lg6>
                <v-datetime-picker
                  format="DD/MM/YYYY HH:mm"
                  label="Seleziona la data di scadenza"
                  okText="Conferma"
                  clearText="Annulla"
                  v-model="expire"
                  locale="it-it"
                ></v-datetime-picker>
              </v-flex>
            </div>
          </v-card-text>
          <v-progress-linear indeterminate active v-if="loading"></v-progress-linear>
          <v-card-actions>
            <v-btn
              :disabled="loading"
              class="q-orange-bk q-text-whitesmoke"
              @click="sendCommunicationAdmin"
            >Invia</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex lg6>
        <v-card class="dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
            <v-toolbar-title>{{
              getString("Lista comunicazioni")
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-data-table
          :loading="isLoading"
            :headers="Headers"
            :items="communications"
            item-key="idCommunication"
            :rows-per-page-items="[10, 20, 30]"
            :rows-per-page-text="getString('Date per pagina')"
            :no-data-text="getString('Dati non disponibili')"
            class="elevation-0"
          >
            <template slot="items" slot-scope="props">
              <tr style="max-height: 100px; overflow: hidden">
                <td class="text-xs-center" style="padding: 0">
                  <v-btn flat @click="deleteCommunication(props.item)">
                    <v-icon class="q-danger-bk">remove_circle</v-icon>
                  </v-btn>
                </td>
                <td class="text-xs-left">
                  {{ getFormattedDateTime(props.item.created) }}
                </td>
                <td class="text-xs-left">{{ props.item.title }}</td>
                <td class="text-xs-left">
                  <v-tooltip bottom>
                    <span
                      slot="activator"
                      v-html="props.item.message.trunc(50)"
                    />
                    <span v-html="props.item.message" />
                  </v-tooltip>
                </td>
                <td class="text-xs-left">
                  {{ getFormattedDate(props.item.expire) }}
                </td>
                
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import ajax from "../../ajax.js";
import Editor from "@tinymce/tinymce-vue";
import moment from "moment";

export default {
  name: "CommunicationAdmin",
  mounted: function() {
    this.getCommunications();
  },
  components: {
    editor: Editor
  },
  computed: {
    titleProp: {
      get: function() {
        return this.title;
      },
      set: function(value) {
        if (value.length <= 30) this.title = value;
      }
    },
    Headers: function () {
      let result = [];
      let self = this;

      let temp = [
         self.getString("Rimuovi"),
        self.getString("Data:date"),
        self.getString("Titolo:title"),
        self.getString("Messaggio:message"),
        self.getString("Scadenza:Expire"),
       
      ];
      temp.forEach((element) => {
        result.push({
          text: self.getString(element.split(":")[0]),
          align: element.split(":").length > 1 ? "left" : "center",
          sortable: element.split(":").length > 1,
          value: element.split(":")[1],
        });
      });
      return result;
    },
    countChar: function() {
      return (
        this.getString("Caratteri: ") + this.stripHtml(this.message).length
      );
    },
    countCharAdmin: function() {
      return (
        this.getString("Caratteri: ") + this.stripHtml(this.messageAdmin).length
      );
    },
    isAdmin: function() {
      return this.$store.getters.isAdmin;
    },
    isFree: function() {
      return this.$store.getters.hasDlc("V10");
    }
  },
  data: () => {
    return {
      loading: false,
      isLoading: false,
      title: "",
      message: "",
      expire: null,
      titleAdmin: "",
      messageAdmin: "",
      expireDialog: false,

      communications: [],

      cb_EmailShop: false,
      cb_PushUser: false,
      cb_PushUsers: true,

      cb_EmailAll: false,
      cb_AlertShops: false,
      cb_PushAll: false
    };
  },
  methods: {
    getString: function(key, values) {
      return this.$store.state.currentTranslator.getString(key, values);
    },
    getFormattedDate: function (date) {
      var date = moment(date);
      if (date.isValid()) return new moment(date).format("DD/MM/YYYY");
      else return "Nessuna";
    },
    getFormattedDateTime: function (date) {
      return new moment(date).format("DD/MM/YYYY HH:mm");
    },
    deleteCommunication: function (item) {
      let self = this;
      this.isLoading = true;

      ajax.axios
        .delete(
          ajax.baseUrl() + "/admin/communication/" + item.idCommunication,
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.getCommunications();
          self.isLoading = false;
        })
        .catch(function (error) {
          self.isLoading = false;
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    getCommunications: function () {
      let self = this;
      this.isLoading = true;
      
      ajax.axios
        .get(ajax.baseUrl() + "/admin/communication", {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true,
        })
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.isLoading = false;
          self.communications = response.data.data;
        })
        .catch(function (error) {
          self.isLoading = false;
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    sendCommunicationAdmin: function() {
      let self = this;
      this.loading = true;

      ajax.axios
        .post(
          ajax.baseUrl() + "/admin/communication/shop/" + 0,
          {
            title: self.titleAdmin,
            message: self.messageAdmin,

            AlertAllShops: self.cb_AlertShops,
            PushAll: self.cb_PushAll,
            EmailAll: self.cb_EmailAll
          },
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true
          }
        )
        .then(function(response) {
          ajax.validateToken(response.headers, self.$store);
          self.loading = false;
          self.$emit("siteAlertSuccess", response.data.data.text);
        })
        .catch(function(error) {
          self.loading = false;
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    stripHtml: function(html) {
      // Create a new div element
      var temporalDivElement = document.createElement("div");
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html;
      // Retrieve the text property of the element (cross-browser support)
      return (
        temporalDivElement.textContent || temporalDivElement.innerText || ""
      );
    }
  }
};
</script>

<style scoped>
.center {
  text-align: center;
}

.counter {
  text-align: right;
  margin-top: 10px;
  color: #666;
  transition: color linear 0.3s;
}

.counter-red {
  color: tomato;
}

.border {
  border: 2px solid;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/CommunicationAdmin.vue